import React from 'react';
import { Button } from '../../../components/base/Button';

export const HeroSection: React.FC = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/6b58f776206411dc99f92669c454c8ce.jpg"
          alt="Casino Background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="flex items-center gap-2 mb-6">
              <div className="flex -space-x-2">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 border-2 border-white"></div>
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-purple-600 border-2 border-white"></div>
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-pink-400 to-pink-600 border-2 border-white"></div>
              </div>
              <span className="text-white text-sm font-medium">Более 50 000 игроков выбрали нас</span>
            </div>

            <h1 className="text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
              Онлайн казино<br />
              <span className="font-light">России 2026</span>
            </h1>
            <p className="text-xl text-white/90 mb-8 leading-relaxed">
              Рейтинг лучших для русскоязычных игроков
            </p>

            <Button variant="light" size="lg" icon="ri-arrow-right-line">
              Смотреть рейтинг
            </Button>
          </div>

          <div className="flex items-end justify-end">
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 max-w-md">
              <p className="text-white text-base leading-relaxed">
                Актуальные обзоры казино с рублевыми счетами, быстрыми выплатами и поддержкой на русском языке
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};